 // Solution (Lösungen) page data structure
 export interface SolutionPage {
   slug: string;
   seoKey: string;
   title: string;
   subtitle: string;
   description: string;
   canonicalUrl: string;
   keywords: string;
   breadcrumbLabel: string;
   serviceName: string;
   serviceDescription: string;
   // Component keys for dynamic rendering
  componentSet: "marketing" | "vertrieb" | "kundenservice" | "ecommerce-solution" | "on-premise";
}

export const solutionPages: SolutionPage[] = [
  {
    slug: "marketing",
    seoKey: "marketing",
    title: "KI Marketing Automation – Lead-Generierung & Kampagnen | Chathero",
    subtitle: "Automatisieren Sie Ihr Marketing mit KI",
    description: "Automatisieren Sie Ihr Marketing mit KI-gestützten Kampagnen, intelligenter Lead-Qualifizierung und personalisierten Customer Journeys.",
    canonicalUrl: "https://chathero.ai/loesungen/marketing",
    keywords: "Marketing Automation, KI Marketing, Lead-Generierung, Kampagnen Automatisierung, Customer Journey, WhatsApp Marketing",
    breadcrumbLabel: "Marketing",
    serviceName: "Chathero Marketing Automation",
    serviceDescription: "KI-gestützte Marketing-Automatisierung: Lead-Generierung, Kampagnen-Management, WhatsApp Marketing.",
    componentSet: "marketing",
  },
  {
    slug: "vertrieb",
    seoKey: "vertrieb",
    title: "AI Agents für Vertrieb – Dialogbasierte Vertriebsunterstützung | Chathero",
    subtitle: "Mehr Abschlüsse durch intelligente Vertriebsunterstützung",
    description: "Mit Chathero AI Agents für Vertrieb automatisieren und optimieren Sie Ihren Verkaufsprozess – von der ersten Anfrage bis zur qualifizierten Übergabe.",
    canonicalUrl: "https://chathero.ai/loesungen/vertrieb",
    keywords: "AI Vertrieb, Sales Automation, Lead-Qualifizierung, CRM Integration, Vertriebsunterstützung, KI Sales",
    breadcrumbLabel: "Vertrieb",
    serviceName: "Chathero AI Agents für Vertrieb",
    serviceDescription: "KI-gestützte Vertriebsunterstützung: Lead-Qualifizierung, CRM-Integration, automatisierte Terminbuchung.",
    componentSet: "vertrieb",
  },
  {
    slug: "kundenservice",
    seoKey: "kundenservice",
    title: "AI Agents für Kundenservice – Intelligenter Support | Chathero",
    subtitle: "Schneller, konsistenter Support durch intelligente Automatisierung",
    description: "Mit Chathero AI Agents für Kundenservice transformieren Sie Ihren Support – von der ersten Anfrage bis zur gezielten Übergabe an Ihr Serviceteam.",
    canonicalUrl: "https://chathero.ai/loesungen/kundenservice",
    keywords: "AI Kundenservice, Support Automation, Live-Chat Übergabe, Omnichannel Support, KI Kundenservice, Service Agent",
    breadcrumbLabel: "Kundenservice",
    serviceName: "Chathero AI Agents für Kundenservice",
    serviceDescription: "KI-gestützter Kundenservice: Automatisierte Anfragebeantwortung, geführte Dialoge, nahtlose Live-Chat-Übergabe.",
    componentSet: "kundenservice",
  },
  {
    slug: "ecommerce",
    seoKey: "ecommerce",
    title: "AI Agents für Produktberatung im E-Commerce | Chathero",
    subtitle: "Intelligente Suche & persönliche Kaufberatung in Echtzeit",
    description: "Mit Chathero AI Agents für Produktberatung verwandeln Sie die Produktsuche in ein dialogbasiertes Einkaufserlebnis.",
    canonicalUrl: "https://chathero.ai/loesungen/ecommerce",
    keywords: "AI E-Commerce, Produktberatung, intelligente Suche, Kaufberatung, Conversational Commerce, Shop AI",
    breadcrumbLabel: "E-Commerce",
    serviceName: "Chathero AI Agents für E-Commerce",
    serviceDescription: "KI-gestützte Produktberatung: Intelligente Suche, personalisierte Empfehlungen, dialogbasiertes Einkaufserlebnis.",
    componentSet: "ecommerce-solution",
  },
];

 export const getSolutionPageBySlug = (slug: string): SolutionPage | undefined => {
   return solutionPages.find((page) => page.slug === slug);
 };
 
 export const getAllSolutionSlugs = (): string[] => {
   return solutionPages.map((page) => page.slug);
 };